export const HIGH_ACCURACY = 'HIGH_ACCURACY';
export const LOW_ACCURACY = 'LOW_ACCURACY';
export const NO_ACCURACY = 'NO_ACCURACY';
export const PROCESSING = 'PROCESSING';
export const COMPLETED = 'COMPLETED';
export const ERRORED = 'ERRORED';

// CSAT Survey Values
export const QA_SURVEY_ID = 352;
export const PROD_SURVEY_ID = 1028;
export const AI_FORECAST_REPORT_PROPERTIES = {
  AI_REPORTING_DATE: 'hs_ai_reporting_date',
  AMOUNT_IN_COMPANY_CURRENCY: 'amount_in_home_currency',
  AVERAGE_PROJECTED_AMOUNT: 'hs_average_projected_amount',
  CLOSE_DATE: 'closedate',
  CLOSED_WON_AGGREGATION: 'hs_closed_won_aggregation',
  CREATE_DATE: 'hs_createdate',
  FISCAL_OFFSET: 'hs_fiscal_offset',
  FORECASTING_CADENCE: 'hs_forecasting_cadence',
  GOAL_AGGREGATION: 'hs_goal_aggregation',
  IS_CLOSED_WON: 'hs_is_closed_won',
  MANUAL_SUBMISSION_AGGREGATION: 'hs_manual_submission_aggregation',
  MAX_PROJECTED_AMOUNT: 'hs_max_projected_amount',
  MIN_PROJECTED_AMOUNT: 'hs_min_projected_amount',
  OBJECT_ID: 'hs_object_id',
  OWNER_ID: 'hubspot_owner_id',
  PIPELINE_ID: 'hs_pipeline_id'
};
export const ANALYZE_EMPTY_STATE_VALUES = {
  HIGH_ACCURACY: {
    dataTestId: 'projections-data-well-empty-state-first-7-days',
    illustrationName: 'errors/hourglass',
    messageName: 'analyze.dataWells.projection.emptyStateMessage'
  },
  LOW_ACCURACY: {
    dataTestId: 'projections-data-well-empty-state-low-accuracy',
    illustrationName: 'empty-state-charts',
    messageName: 'analyze.dataWells.projection.emptyStateLowAccuracy'
  },
  NO_ACCURACY: {
    dataTestId: 'projections-data-well-empty-state-low-data',
    illustrationName: 'empty-state-charts',
    messageName: 'analyze.dataWells.projection.emptyStateLowData'
  }
};
export const getOverallAccuracyType = (hasForecastProjections, portalHasMetAccuracyThreshold) => {
  if (!hasForecastProjections) {
    return NO_ACCURACY;
  }
  if (!portalHasMetAccuracyThreshold) {
    return LOW_ACCURACY;
  }
  return HIGH_ACCURACY;
};